/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { sendGTMLoginLessSubmitEvent } from '@/data/events/handlers/gtm/LoginLessSubmit';
import { GTMLoginLessSubmitPayload } from '@/data/types/GTM';

type LoginLessSubmitDelegatorProps = {
	gtm?: GTMLoginLessSubmitPayload;
};

export const loginLessSubmitDelegator = async (payload: LoginLessSubmitDelegatorProps) => {
	const { gtm } = payload;
	if (gtm) {
		await sendGTMLoginLessSubmitEvent(gtm);
	}
};
